import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Text from '../../../../shared/Text';

export const NotConfigured = () => {
  return <Badge variant="small5">NOT CONFIGURED</Badge>;
};

const Badge = styled(Text)`
  display: flex;
  padding: 1.9px 4.75px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4.75px;
  border-radius: 3.8px;
  background: ${themeGet('colors.warning.default')};
`;
